<template>
  <!-- 投诉工单新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增投诉工单'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 发起人（必填） -->
          <a-form-item label="发起人" name="userId">
            <a-input
              v-model:value="form.userId"
              disabled
              placeholder="自动填入账号信息"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 发起源（必填，默认2-管理后台，禁用） -->
          <a-form-item label="发起源" name="fromType">
            <a-select
              v-model:value="form.fromType"
              placeholder="请选择发起源"
              disabled
            >
              <a-select-option
                v-for="dict in dict.type['originator']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 类型（必填） -->
          <a-form-item label="类型" name="type">
            <a-select
              v-model:value="form.type"
              placeholder="请选择类型"
              allow-clear
            >
              <a-select-option
                v-for="dict in dict.type['complaint_type']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 所在空间（必填） -->
          <a-form-item label="所在空间" name="spaceId">
            <a-select
              v-model:value="form.spaceId"
              show-search
              placeholder="请选择所在空间"
              allow-clear
              :filter-option="false"
              :not-found-content="null"
              @search="handleSpaceSearch"
              @focus="handleSpaceFocus"
              @change="handleSpaceChange"
            >
              <template v-slot:notFoundContent>
                <a-spin size="small" v-if="spaceLoading" />
              </template>
              <a-select-option
                v-for="space in spaceOptions"
                :key="space.id"
                :value="space.id"
              >
                {{ space.name || space.spaceName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 问题描述（必填） -->
          <a-form-item label="问题描述" name="description">
            <a-input
              v-model:value="form.description"
              placeholder="请输入内容"
              type="textarea"
              allow-clear
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="24">
          <!-- 照片 -->
          <a-form-item label="照片" name="url">
            <file-upload
              :value="form.url"
              type="image"
              :count="9"
              field-name="url"
              @change="handlePhotoChange"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 投诉工单新增/编辑抽屉表单
 * - 字段与前端列表保持一致
 * - 空间来自项目维度的远程下拉
 * - 新增时自动带入当前登录人和项目
 */
import {
  getComplaintOrder,
  addComplaintOrder,
  updateComplaintOrder,
} from '@/api/system/complaintOrder'
import { listSpace } from '@/api/system/space'

export default {
  name: 'CreateForm',
  dicts: ['originator', 'complaint_type'],
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数（与后端保持一致）
      form: {
        id: null,
        userId: undefined,
        fromType: 2, // 默认值：2-管理后台
        type: undefined,
        projectId: undefined,
        spaceId: undefined,
        description: undefined,
        url: undefined,
      },
      // 1新增、2修改
      formType: 1,
      open: false,
      // 空间选择相关状态
      spaceOptions: [],
      spaceLoading: false,
      selectedSpaceName: '',
      // 表单必填规则（除照片外均必填）
      // rules: {
        // userId: [
        //   { required: true, message: '发起人不能为空', trigger: 'change' },
        // ],
        // fromType: [
        //   { required: true, message: '请选择发起源', trigger: 'change' },
        // ],
        // type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        // spaceId: [
        //   { required: true, message: '所在空间不能为空', trigger: 'change' },
        // ],
        // description: [
        //   { required: true, message: '请输入问题描述', trigger: 'blur' },
        // ],
      // },
    }
  },
  created() {},
  computed: {},
  watch: {
    // 监听字典数据加载完成，确保发起源字段能正确显示
    'dict.type.originator'(newVal) {
      if (newVal && newVal.length > 0 && this.formType === 1 && !this.form.id) {
        // 新增时，确保fromType值为2（管理后台）
        // 检查字典中是否存在值为2的项，如果存在则设置为匹配的值类型
        const target = newVal.find(item => item.value == 2 || item.value === '2')
        if (target && this.form.fromType !== target.value) {
          this.form.fromType = target.value
        }
      }
    },
  },
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    /**
     * 处理照片多图上传
     * FileUpload 组件在多图模式下会返回对象，包含 url 字段（逗号拼接的图片地址）
     * @param {Object|String} data 上传回调
     */
    handlePhotoChange(data) {
      if (typeof data === 'object' && data !== null) {
        if (data.url !== undefined) {
          this.form.url = data.url
        }
      } else if (typeof data === 'string') {
        this.form.url = data
      }
    },
    /**
     * 空间搜索
     * @param {string} value
     */
    handleSpaceSearch(value) {
      this.loadSpaceOptions(value)
    },
    /**
     * 聚焦时加载空间
     */
    handleSpaceFocus() {
      if (!this.spaceOptions.length) {
        this.loadSpaceOptions()
      }
    },
    /**
     * 选择空间时记录名称
     */
    handleSpaceChange(value) {
      const target = this.spaceOptions.find((item) => item.id === value)
      this.selectedSpaceName = target
        ? target.name || target.spaceName || ''
        : ''
    },
    /**
     * 根据项目加载空间选项
     * @param {string} keyword
     * @param {string|number} customProjectId
     * @param {boolean} ensureSelected
     */
    loadSpaceOptions(keyword = '', customProjectId, ensureSelected = false) {
      const projectId =
        customProjectId ||
        this.form.projectId ||
        this.$store.getters.currentProjectId
      if (!projectId) {
        this.spaceOptions = []
        return Promise.resolve()
      }
      this.spaceLoading = true
      const params = {
        projectId: projectId,
      }
      if (keyword) {
        params.name = keyword
        params.spaceName = keyword
      }
      return listSpace(params)
        .then((response) => {
          let list = []
          if (
            response &&
            (response.code === 200 ||
              response.code === 20001 ||
              response.success)
          ) {
            list = response.data || []
          }
          this.spaceOptions = list
          if (ensureSelected && this.form.spaceId) {
            const exists = this.spaceOptions.some(
              (item) => item.id === this.form.spaceId
            )
            if (!exists) {
              const label =
                this.selectedSpaceName ||
                this.form.spaceName ||
                this.form.spaceId
              this.spaceOptions.push({
                id: this.form.spaceId,
                name: label,
                spaceName: label,
              })
            }
          }
        })
        .catch(() => {
          this.spaceOptions = []
          this.$message.error('获取空间列表失败，请稍后重试', 3)
        })
        .finally(() => {
          this.spaceLoading = false
        })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      // 先设置基本表单数据
      this.form = {
        id: null,
        userId: undefined,
        fromType: 2, // 默认值：2-管理后台，后续会根据字典数据类型调整
        type: undefined,
        projectId: undefined,
        spaceId: undefined,
        description: undefined,
        url: undefined,
      }
      
      // 如果字典数据已加载，使用字典中的实际值类型
      this.$nextTick(() => {
        if (this.dict && this.dict.type && this.dict.type['originator'] && this.dict.type['originator'].length > 0) {
          const target = this.dict.type['originator'].find(item => item.value == 2 || item.value === '2')
          if (target) {
            this.form.fromType = target.value
          }
        }
      })
      
      this.spaceOptions = []
      this.selectedSpaceName = ''
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /**
     * 打开新增抽屉
     * - 重置表单
     * - 注入当前项目并预加载空间列表
     * - 设置发起源默认值为2（管理后台）
     */
    handleAdd() {
      this.reset()
      this.formType = 1
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.form.projectId = currentProjectId
      }
      
      // 确保发起源默认值为2（管理后台），并匹配字典中的值类型
      this.$nextTick(() => {
        if (this.dict && this.dict.type && this.dict.type['originator'] && this.dict.type['originator'].length > 0) {
          // 查找值为2的字典项，使用字典中的实际值类型（可能是字符串或数字）
          const target = this.dict.type['originator'].find(item => item.value == 2 || item.value === '2')
          if (target) {
            this.form.fromType = target.value
          } else {
            // 如果找不到，使用数字2作为默认值
            this.form.fromType = 2
          }
        } else {
          // 如果字典还没加载，先设置为2，watch会在字典加载后更新
          this.form.fromType = 2
        }
      })
      
      this.loadSpaceOptions('', this.form.projectId)

      this.open = true
      this.formTitle = '添加'
    },
    /**
     * 打开编辑抽屉
     * - 根据ID加载详情
     * - 保证空间下拉中包含当前选中项
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getComplaintOrder({ id: id }).then((response) => {
        this.form = response.data
        this.selectedSpaceName = response.data.spaceName || ''
        this.loadSpaceOptions('', this.form.projectId, true)
        this.open = true
        this.formTitle = '修改'
      })
    },
    /**
     * 提交表单
     * - 新增时自动补全发起人
     * - 统一调用校验与接口
     */
    submitForm: function () {
      if (this.formType == 1) {
        const currentUser = this.$store.getters.userInfo || {}
        const loginUserId = currentUser.userId || currentUser.id
        if (loginUserId) {
          this.form.userId = loginUserId
        }
      }

      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        if (this.form.id !== undefined && this.form.id !== null) {
          updateComplaintOrder(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          addComplaintOrder(this.form)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      }).catch(() => {
        // 验证失败
        return false
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 0;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
